module.exports = __webpack_public_path__ + "img/Strip-Front-B2-Cd-Jc.af6c00d4.png";